"use client"

export default function CourseFinalCTA() {
  return (
    <section className="relative py-24 sm:py-32 lg:py-40 overflow-hidden">
      {/* Background glow effect */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_50%,rgba(0,158,61,0.15),transparent_70%)]"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950/50 via-transparent to-slate-950/50"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-montserrat font-bold mb-16 leading-[1.1] sm:leading-[1.1] lg:leading-[1.1]"
              style={{ color: "#FFFFFF" }}
            >
              Ready to go from <span style={{ color: "#009E3D" }}>LLM prompts</span>
              <br />
              to real <span style={{ color: "#009E3D" }}>Enterprise</span> AI Agent
              <br />
              systems?
            </h2>

            <div className="relative">
              {/* Glow effect behind button */}
              <div className="absolute inset-0 bg-gradient-radial from-green-500/30 via-green-500/20 to-transparent blur-2xl transform scale-150 animate-pulse"></div>

              <a
                href="https://maven.com/rakeshgohel/ai-agent-engineering-react-rag-multi-agent"
                target="_blank"
                rel="noopener noreferrer"
                className="relative inline-flex items-center justify-center font-vietnam font-bold px-12 py-6 rounded-lg transition-all duration-300 transform hover:scale-105 text-xl"
                style={{
                  backgroundColor: "#009E3D",
                  color: "#020617",
                  boxShadow: `
                    0 0 30px rgba(0, 158, 61, 0.6),
                    0 0 60px rgba(0, 158, 61, 0.4),
                    0 0 90px rgba(0, 158, 61, 0.3),
                    0 8px 32px rgba(0, 0, 0, 0.3)
                  `,
                  filter: "drop-shadow(0 0 20px rgba(0, 158, 61, 0.5))",
                }}
              >
                <span>Enroll now on </span>
                <span className="ml-2 font-bold">maven</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
